"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IDisposable.js.map